export const orderTypeMap = {
    shuffled: 'shuffled',
    repeated: 'repeated',
    none: 'none'
};